/*----------------------------------------------------------------------
    Function: getLeavingMs
----------------------------------------------------------------------*/
function getLeavingMs() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--frontend-transition-timing-fast').trim();

    const seconds = parseFloat(raw);
    if (!Number.isFinite(seconds)) return 250;

    return Math.round(seconds * 1000);
}

/*----------------------------------------------------------------------
    Function: handleInternalNav
----------------------------------------------------------------------*/
function handleInternalNav(e) {
    const link = e.target.closest('a[role="menuitem"]');
    if (!link) return;

    if (link.origin !== location.origin) return;
    if (link.hash) return;
    if (link.target === '_blank') return;

    e.preventDefault();

    document.documentElement.classList.add('is-leaving');

    window.setTimeout(() => {
        window.location.href = link.href;
    }, getLeavingMs());
}

/*----------------------------------------------------------------------
    Function: initFrontend
----------------------------------------------------------------------*/
async function initFrontend() {
    const root = document.documentElement;
    const nextFrame = () => new Promise((resolve) => requestAnimationFrame(resolve));

    try {
        await window.__cmsSystem.setAppContentFrontend();
        await window.__cmsSystem.load();
        await window.__cmsSystem.initFrontend();

        window.addEventListener('click', handleInternalNav, true);

        let lForm = false;
        const widgets = window.cmsFrontedWidgets;

        Object.values(widgets || {}).forEach((group) => {
            // Widget: form
            if (group.type === "form") {
                lForm = true;
                window.shared_Forms?.bubbleRange?.();
                window.shared_ColorPicker?.init?.('grid-system-render-layout');
            }

            // Widget: text
            if (group.type === "text") {
                // Syntax highlight code blocks from quill editors
                document.querySelectorAll('pre[data-language]').forEach((block) => {
                    // 1. Get the language from the data attribute
                    const lang = block.getAttribute('data-language');

                    // 2. Wrap the inner text in a <code> tag (which hljs expects)
                    const code = document.createElement('code');
                    code.className = `language-${lang}`;
                    // code.innerHTML = block.innerHTML;

                    // 3. Clear the <pre> and append the new <code>
                    block.innerHTML = '';
                    block.appendChild(code);

                    // 4. Highlight it
                    window.hljs?.highlightElement?.(code);
                });
            }
        });


        await nextFrame();

        root.classList.add('is-ready');
        root.setAttribute('data-ready', '1');

        if (lForm) {
            const enableFormAnimations = (event) => {
                if (event?.isTrusted === false) return;
                root.classList.add('cms-forms-interactive');
                ['pointerdown', 'keydown', 'input', 'change', 'submit'].forEach((type) => {
                    document.removeEventListener(type, enableFormAnimations, true);
                });
            };
            ['pointerdown', 'keydown', 'input', 'change', 'submit'].forEach((type) => {
                document.addEventListener(type, enableFormAnimations, true);
            });
        }

    } catch (err) {
        const container = document.getElementById('index-body');
        if (container) {
            container.innerHTML = `<p class="error">Failed to initialize Frontend. ${err}</p>`;
        }
        root.classList.add('is-ready');
        root.setAttribute('data-ready', '1');
    }
}

document.addEventListener('DOMContentLoaded', initFrontend);
